export const RESET = 'CONFTYPE_LIST_RESET'
export const SET_ITEMS = 'CONFTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'CONFTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'CONFTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'CONFTYPE_LIST_TOGGLE_LOADING'
